import { mdiStarCircle, mdiAccountBox, mdiInformation } from "@mdi/js";
import { MenuListItem, IMenuList } from "../../../model";

export enum studySitePersonnelMenuItemCategories {
  GeneralInfo = "General",
  Experience = "Experience",
  Training = "Training"
}

export class StudySitePersonnelMenuContainer implements IMenuList {
  // This will be the interface structure used for the component to make it generic
  public menuItems: MenuListItem[];
  public constructor() {
    this.menuItems = this.getMenu();
  }
  public getMenu() {
    const menuList = [
      new MenuListItem(
        "General Info",
        mdiAccountBox,
        "/study/:id/sites/:siteId/personnel/:personnelId",
        studySitePersonnelMenuItemCategories.GeneralInfo
      ),
      new MenuListItem(
        "Experience",
        mdiStarCircle,
        "/study/:id/sites/:siteId/personnel/:personnelId/experience",
        studySitePersonnelMenuItemCategories.Experience
      ),
      new MenuListItem(
        "Training",
        mdiInformation,
        "/study/:id/sites/:siteId/personnel/:personnelId/training",
        studySitePersonnelMenuItemCategories.Training
      )
    ];
    return menuList;
  }
}
